import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {
  refreshToken: string | undefined;

  constructor(@Inject(DOCUMENT) private document: Document) { }

  public get(): string | undefined {
    const cookieValue = this.getCookie('refresh-token');
    if (cookieValue) {
      this.refreshToken = cookieValue;
    } else {
      this.refreshToken = undefined;
    }

    return this.refreshToken;
  }

  public set(refreshToken: string, expirationDate?: Date) {
    if (!expirationDate) {
      expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 7);
    }

    this.setCookie('refresh-token', refreshToken, expirationDate);
    this.refreshToken = refreshToken;
  }

  public remove() {
    this.setCookie('refresh-token', '', new Date(0));
    this.refreshToken = undefined;
  }

  private setCookie(name: string, value: string, expirationDate: Date) {
    if (typeof expirationDate === 'string') {
      expirationDate = new Date(expirationDate);
    }
    const secureFlag = 'Secure';
    const sameSiteFlag = 'SameSite=Strict';
    this.document.cookie = `${name}=${value};expires=${expirationDate.toUTCString()};path=/;${secureFlag};${sameSiteFlag}`;
  }

  private getCookie(name: string): string | null {
    const nameEQ = name + '=';
    const cookies = this.document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }
}
